import * as Yup from 'yup';

import { CODE_LENGTH } from 'features/authentication/SignIn/constants';

import { toI18n } from 'util/i18n';

export const codeValidationSchema = Yup.object().shape({
  code: Yup.string()
    .min(CODE_LENGTH, toI18n('authentication.errors.code_invalid'))
    .required(toI18n('authentication.errors.code_required')),
});
